import React, { PropsWithChildren } from 'react';
import cx from 'classnames';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import postSaleLayoutStyles from 'Containers/app/postSale/components/PostSaleLayout/PostSaleLayout.scss';

import PageHeader from '../../../common/PageHeader/PageHeader';

import styles from './ChevronPageHeader.scss';

export const ChevronPageHeader: React.FC<PropsWithChildren> = ({ children }) => (
  <PageHeader className={styles.pageHeader}>
    <ComponentContent
      className={cx(postSaleLayoutStyles.contentWrapper, styles.contentWrapper)}
      maxWidth={CONTENT_SIZES.container}
      paddings={false}
    >
      <div className={styles.heroContent}>
        <div className={styles.hero}>
          {children}
        </div>
      </div>
    </ComponentContent>
  </PageHeader>
);
